// extracted by mini-css-extract-plugin
module.exports = {"error":"PayFabricHostedForm_error__sbYX1","container":"PayFabricHostedForm_container__-EgRc","iFrame":"PayFabricHostedForm_iFrame__1oL7e"};